import activeApiCall from './active';
import analysisApiCall from './analysis';
import createApiCall from './create';
import deleteApiCall from './delete';
import detailApiCall from './detail';
import editApiCall from './edit';
import listApiCall from './list';
import pauseApiCall from './pause';
import portfolioApiCall from './portfolio';
import portfolioItemsApiCall from './portfolio-items';
import performanceChartApiCall from './performanceChart';
import portfolioAnalyticsApiCall from './portfolioAnalytics';

const ApiCall = {
  list: listApiCall,
  detail: detailApiCall,
  create: createApiCall,
  edit: editApiCall,
  delete: deleteApiCall,
  active: activeApiCall,
  pause: pauseApiCall,
  portfolio: portfolioApiCall,
  portfolioItems: portfolioItemsApiCall,
  analytics: portfolioAnalyticsApiCall,
  performanceChart: performanceChartApiCall,
  analysis: analysisApiCall,
};

export default ApiCall;
